
export default function ContactDetails() {
  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      detail: '0800 123 4567',
      subtext: 'Mon-Fri, 7am-6pm'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      detail: 'info@bestbuilding.co.uk',
      subtext: 'We reply within 24 hours'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Head Office',
      detail: '42 Trade Park Way, Manchester M17 1QS',
      subtext: 'Trade counter open Mon-Sat'
    }
  ];

  return (
    <div className="space-y-5 overflow-x-hidden">
      <div className="bg-white rounded-lg shadow-sm p-4 md:p-8">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center md:text-left" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Contact Information
        </h2>
        
        <div className="space-y-5">
          {contactMethods.map((method, index) => (
            <div key={index} className="flex flex-col sm:flex-row items-center sm:items-start gap-3 text-center sm:text-left">
              <div className="w-12 h-12 bg-[#F2C612] rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${method.icon} text-2xl text-[#1A1A1A]`}></i>
              </div>
              <div>
                <h3 className="font-semibold text-lg mb-1">{method.title}</h3>
                <p className="text-gray-700 mb-1 break-words">{method.detail}</p>
                <p className="text-sm text-gray-500">{method.subtext}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-4 md:p-8">
        <h3 className="text-xl font-bold mb-4 text-center md:text-left" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Opening Hours
        </h3>
        <div className="space-y-2 text-gray-700 text-sm md:text-base">
          <div className="flex justify-between gap-4">
            <span>Monday - Friday</span>
            <span className="font-semibold whitespace-nowrap">7:00 AM - 6:00 PM</span>
          </div>
          <div className="flex justify-between gap-4">
            <span>Saturday</span>
            <span className="font-semibold whitespace-nowrap">8:00 AM - 4:00 PM</span>
          </div>
          <div className="flex justify-between gap-4">
            <span>Sunday</span>
            <span className="font-semibold whitespace-nowrap">Closed</span>
          </div>
        </div>
      </div>
    </div>
  );
}
